import StageSelectedFiles from './StageSelectedFiles.component';

export default StageSelectedFiles;
